import {
  useQuery,
} from '@tanstack/react-query';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
import { getOrderPublicReceipt } from '../../services/publics.service';
const listQueryKey = 'publics';

export const useGetPublicOrderReceipt = (
  publicToken: string,
  options?: { enabled?: boolean; retry?: boolean | number }
) => {
  return useQuery<any>({
    queryKey: [listQueryKey, { _id: publicToken }],
    enabled: !!publicToken?.trim() && (options?.enabled ?? true),
    retry: options?.retry ?? true,
    queryFn: async () => {
      try {
        const res = await getOrderPublicReceipt(publicToken);
        if (!res?.data?.data) {
          throw new Error('No se encontró el pedido.');
        }
        return res.data.data;
      } catch (e: any) {
        console.log('error caught', e?.response?.data?.errors);
        throw backendErrorsHandler(e);
      }
    }
  });
};

